package kpt.core.database

import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Suppress

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class AppDatabase_AutoMigration_5_6_Impl : Migration {
  public constructor() : super(5, 6)

  public override suspend fun migrate(connection: SQLiteConnection) {
    connection.execSQL("CREATE TABLE IF NOT EXISTS `personal_watchlist` (`coinId` TEXT NOT NULL, `addedAtMs` INTEGER NOT NULL, PRIMARY KEY(`coinId`))")
  }
}
